"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var G = tslib_1.__importStar(require("@antv/g"));
var g2_1 = require("@antv/g2");
var _ = tslib_1.__importStar(require("@antv/util"));
function funnelScaleInY(shape, animateCfg, coord) {
    var _a = animateCfg || {}, _b = _a.duration, duration = _b === void 0 ? 200 : _b, easing = _a.easing, callback = _a.callback, reverse = _a.reverse;
    var box = shape.getBBox();
    var originX = (box.minX + box.maxX) / 2;
    var originY = reverse ? box.minY : box.maxY;
    var shapeIndex = shape.get('index');
    var clip = getClip(coord);
    var clipTargetMatrix = _.clone(clip.attr('matrix'));
    clip.attr('transform', [
        ['t', -originX, -originY],
        ['s', 1, 0],
        ['t', originX, originY],
    ]);
    var shapeTargetFillOpacity = shape.attr('fillOpacity');
    shape.attr('fillOpacity', 0);
    shape.attr('clip', clip);
    clip.animate({
        matrix: clipTargetMatrix,
    }, duration, easing, function () {
        clip.remove();
        shape.attr('clip', null);
    }, shapeIndex * duration);
    shape.animate({
        fillOpacity: shapeTargetFillOpacity,
    }, duration, easing, null, shapeIndex * duration);
    callback && setTimeout(function () { return callback(shape); }, duration + shapeIndex * duration);
}
function getClip(coord) {
    var start = coord.start, end = coord.end, width = coord.width, height = coord.height;
    var clip = new G.Shapes.Rect({
        attrs: {
            x: start.x,
            y: end.y,
            width: width,
            height: height,
        },
    });
    return clip;
}
funnelScaleInY.animationName = 'funnelScaleInY';
g2_1.Animate.registerAnimation('appear', 'funnelScaleInY', funnelScaleInY);
//# sourceMappingURL=funnel-scale-in-y.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/funnel/animation/funnel-scale-in-y.js
// module id = 896
// module chunks = 37